module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-view"
  }, [_c('div', {
    staticClass: "twui-404",
    style: ({
      minHeight: _vm.minHeight
    })
  }, [_c('div', {
    staticClass: "twui-404-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../static/images/404.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("很抱歉，页面走丢了")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.backPrevPage
    }
  }, [_vm._v("返回上一个页面")]), _vm._v(" "), _c('a', [_vm._v("重新登录")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-296150a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/404.vue
// module id = 590
// module chunks = 1